import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { api, getUserName } from '../hooks';

export const useIblTranslation = () => {
  const { i18n } = useTranslation(); // Default namespace
  const [languages, setLanguages] = useState<{ string: string } | {}>({});

  useEffect(() => {
    fetch('/languages.json')
      .then((response) => response.json())
      .then((data) => setLanguages(data))
      .catch((error) => {
        console.log('Error fetching languages:', error);
        setLanguages({ en: 'English' });
      });
  }, []);

  useEffect(() => {
    document.documentElement.setAttribute('dir', i18n.dir(i18n.language));
  }, []);

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      console.log('Language changed to:', lng);
      document.documentElement.setAttribute('dir', i18n.dir(lng));
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  const translate = (lang: string, namespaces?: string[]) => {
    const configuredNs = i18n.options.ns;
    let ns = ['library'];
    if (namespaces) {
      ns = namespaces;
    } else if (configuredNs) {
      if (typeof configuredNs === 'string') {
        ns = [configuredNs];
      } else if (Array.isArray(configuredNs)) {
        ns = configuredNs;
      }
    }
    i18n.changeLanguage(lang); // Change language for default namespace
    document.documentElement.setAttribute('dir', i18n.dir(lang));
    ns.forEach((namespace) => translateWithNamespace(namespace));
    api.ibledxusers.patchUserPreference({
      'pref-lang': lang,
      username: getUserName(),
    });
    api.ibledxusers.setLanguage({ language: lang });
  };

  // If you need to handle a different namespace within the library
  const translateWithNamespace = (namespace: string) => {
    i18n.loadNamespaces(namespace); // Optionally load namespace
  };

  return {
    translate,
    languages,
  };
};
